export const resumeBuilderSelector = state => state.resumeBuilder;
